export default () => ({
    pdf: {
        marginTop: '20px',
    },
    button: {
        marginTop: '10px',
    },
    media: {
        height: '100vh',
        width: '70vw',
        marginTop: '20px',
        border: '2px solid grey',
    },
    buttonText: {
        color: 'white',
        textDecoration: 'none',
    },
})
